import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';

// Same sliding-pill tab bar pattern as Inventory's own TabBar (src/app/inventory/index.js),
// generalized (no per-tab icon requirement) so it can sit inside a card, not just as a
// full page-level switcher. Not shared with Inventory's file to keep this module's
// footprint scoped to itself, per the rest of the Maintenance build.
const TabBar = ({ tabs, activeTab, onChange, size = 'md' }) => {
    const tabRefs = useRef({});
    const [indicator, setIndicator] = useState(null);

    useLayoutEffect(() => {
        const el = tabRefs.current[activeTab];
        if (el) setIndicator({ left: el.offsetLeft, width: el.offsetWidth });
    }, [activeTab, tabs.length]);

    useEffect(() => {
        const handleResize = () => {
            const el = tabRefs.current[activeTab];
            if (el) setIndicator({ left: el.offsetLeft, width: el.offsetWidth });
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [activeTab]);

    const padding = size === 'sm' ? 'px-3 py-1.5 text-xs' : 'px-4 py-2.5 text-sm';

    return (
        <div className="relative inline-flex gap-1 rounded-xl border border-inv-cream-200 bg-inv-cream-100/40 p-1 shadow-sm">
            {indicator && (
                <div
                    className="absolute top-1 bottom-1 rounded-lg bg-inv-brand shadow-[0_8px_18px_-10px_rgba(194,87,26,0.7)] transition-all duration-300 ease-out"
                    style={{ left: indicator.left, width: indicator.width }}
                />
            )}
            {tabs.map((tab) => {
                const active = activeTab === tab.key;
                return (
                    <button
                        key={tab.key}
                        type="button"
                        ref={(el) => { tabRefs.current[tab.key] = el; }}
                        onClick={() => onChange(tab.key)}
                        className={`relative z-10 shrink-0 rounded-lg font-semibold transition-colors duration-300 ${padding} ${
                            active ? 'text-white' : 'text-[#6B675F] hover:text-inv-ink'
                        }`}
                    >
                        {tab.label}
                    </button>
                );
            })}
        </div>
    );
};

export default TabBar;
